import React, * as react from 'react';
import * as router from 'react-router-dom';

export const ReturnLocationContext = (
  react.createContext<string | null>(null)
);

export const storageKey = 'returnToURL';

export function ReturnLocationProvider(
  { children }: { children: react.ReactNode}
) {
  const [searchParams, _] = router.useSearchParams();

  // We read from *both* search params *and* local storage because
  // search params get lost during the OIDC flow's redirects!
  // (...and it also simplifies the logic to not have to always
  // append search params on internal navigation...)
  // Prioritizing search params allows "new" navigations into
  // the identity app to set a fresh returnTo even if a stale one
  // is still in local storage.
  const returnURL = (
    searchParams.get('returnTo')
    ?? localStorage.getItem(storageKey)
    ?? null
  );

  if (returnURL !== null) {
    localStorage.setItem(storageKey, returnURL);
  }

  return <ReturnLocationContext.Provider value={returnURL}>
    {children}
  </ReturnLocationContext.Provider>;
}

export function useReturn() {
  const returnURL = react.useContext(ReturnLocationContext);
  const navigate = router.useNavigate();

  function doReturn() {
    if (returnURL === null) {
      return navigate('/');
    }
    window.location.href = returnURL;
  };

  // usage note: URLSearchParams objects can be conveniently combined, eg:
  // `new URLSearchParams([...paramsA.entries(), ...paramsB.entries()]);`
  // (and then stringified)
  const searchParams = new URLSearchParams();
  if (returnURL !== null) {
    searchParams.set('returnTo', returnURL);
  }

  return {
    go: doReturn,
    url: returnURL,
    searchParams
  };
}

export function Return() {
  const { go } = useReturn();
  go();
  return <div>The browser should have been redirected.</div>;
}
